module.exports = __webpack_public_path__ + "e4dd5c60d0ebf6d6e1227a312b7c4378.woff";